import type { Money } from '../schemas/primitives.js';

/**
 * Compute prorated charge for an outlet added on `day` of a month with `daysInMonth` days,
 * at the given `extraOutletPrice` (sen). Includes the current day.
 */
export function prorate(extraOutletPrice: Money, day: number, daysInMonth: number): Money {
  if (day < 1 || day > daysInMonth) throw new RangeError('day must be in [1, daysInMonth]');
  if (daysInMonth < 28 || daysInMonth > 31) throw new RangeError('daysInMonth must be 28..31');
  const daysRemaining = daysInMonth - day + 1;
  return Math.round((daysRemaining / daysInMonth) * extraOutletPrice);
}

/** Number of days in `month` (1..12) of `year`. */
export function daysInMonth(year: number, month: number): number {
  if (month < 1 || month > 12) throw new RangeError('month must be 1..12');
  return new Date(year, month, 0).getDate();
}

/** Convenience: prorate today (Asia/Kuala_Lumpur) given the given `now`. */
export function prorateAt(extraOutletPrice: Money, now: Date): Money {
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  return prorate(extraOutletPrice, day, daysInMonth(year, month));
}
